import * as Sentry from "@sentry/react";

export const initSentry = () => {
 const dsn = process.env.REACT_APP_SENTRY_DSN;
 const env = process.env.NODE_ENV || "development";

 if (!dsn) {
  console.warn("Sentry DSN not found. Skipping initialization.");
  return;
 }

 Sentry.init({
  dsn,
  environment: env,
  integrations: [
   Sentry.browserTracingIntegration(),
   Sentry.replayIntegration({
    blockAllMedia: true,
   })
  ],

  // 100% of transactions in production, 50% in development
  tracesSampleRate: env === "production" ? 1.0 : 0.5,

  // 10% of sessions recorded normally, 100% on error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  ignoreErrors: [
   "TypeError: Failed to fetch",
   "NetworkError when attempting to fetch resource",
  ],
 });
};

export const showSentryReport = () => {
 const eventId = Sentry.lastEventId();
 if (eventId) {
  Sentry.showReportDialog({ eventId });
 }
};
